module.exports = __webpack_public_path__ + "static/media/bursts_14.a9673af8.svg";